import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterX = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M18 4q.65 0 .912.55.263.549-.112 1.05L13 13v6a.97.97 0 0 1-.288.713A.97.97 0 0 1 12 20h-2a.97.97 0 0 1-.713-.287A.97.97 0 0 1 9 19v-6L3.2 5.6q-.375-.501-.113-1.05Q3.35 4 4 4zm-7 8.3L15.95 6h-9.9z" }), /* @__PURE__ */ _jsx("path", { d: "m23.414 15.557-3.15 3.15 3.15 3.15-1.557 1.557-3.15-3.15-3.15 3.15L14 21.857l3.15-3.15-3.15-3.15L15.557 14l3.15 3.15 3.15-3.15z" })]
});
export default SvgFilterX;
